<template>
  <v-card flat>
    <form
      ref="downloadForm"
      method="post"
      :action="downloadUrl"
      style="display: none"
    >
      <input
        ref="downloadInput"
        name="Authorization"
        :value="authToken"
        type="hidden"
      />
    </form>
    <v-col cols="12" class="px-0 pb-0">
      <v-btn color="primary" icon @click="handleBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="text-h6 mr-2" style="vertical-align: middle">
        {{ $t('message.pages.video.qualities') }}
      </span>
    </v-col>
    <v-col cols="12">
      <span>
        {{ $t('message.pages.video.qualitiesMessage') }}
      </span>
    </v-col>
    <v-col v-if="errors.fetch" cols="12">
      <v-row justify="center" class="mt-7 mb-3">
        <span>{{
          $t('message.pages.video.metricsPage.videoTrafficError')
        }}</span>
      </v-row>
      <v-row class="mt-5" justify="center">
        <v-btn
          color="primary"
          @click="fetchData"
          :loading="loadings.fetch"
          :disabled="loadings.fetch"
        >
          {{ $t('message.pages.newLive.tryAgain') }}
        </v-btn>
      </v-row>
    </v-col>
    <v-col v-else-if="loadings.fetch" cols="12">
      <v-row align="center" class="mt-5" justify="center">
        <v-progress-circular
          indeterminate
          color="primary"
          class="mb-4"
        ></v-progress-circular>
      </v-row>
    </v-col>
    <v-col cols="12" v-else class="px-0 list-storage-video">
      <v-card flat>
        <v-list>
          <v-list-item class="justify-space-between" style="margin-top: -8px">
            <b style="width: 100%">Item</b>
            <b style="width: 100%; text-align: right" class="pr-7">{{
              $t('message.size')
            }}</b>
            <b style="width: 100%; text-align: center">TS</b>
            <b style="text-align: center" class="pl-4">
              {{ $t('message.pages.video.quality') }}<br />
              {{ $t('message.pages.video.initial') }}
            </b>
          </v-list-item>
          <v-card
            flat
            v-for="(storageItem, index) in sizesList"
            :key="`${storageItem.name}--${index}`"
            class="storage-video-card"
          >
            <template v-if="storageItem.available">
              <v-list-item
                class="justify-space-between"
                :class="storageItem.disabled === true ? 'disabled-quality' : ''"
              >
                <div style="width: 100%" class="d-flex align-center">
                  {{ storageItem.name }}
                  <p
                    style="cursor: pointer"
                    class="unavailable-quality mb-0 quality-button"
                    v-if="storageItem.disabled === true"
                    @click="handleShowModal(storageItem.name)"
                  >
                    {{ $t('message.disabled') }}
                  </p>
                  <p
                    style="cursor: pointer"
                    class="unavailable-quality mb-0 quality-button enabled-quality"
                    v-else
                    @click="handleShowModal(storageItem.name, true)"
                  >
                    {{ $t('message.pages.qualitySettings.enabled') }}
                  </p>
                </div>
                <div style="width: 100%" class="text-end pr-0">
                  {{
                    addDecimal(
                      calcMegabytes(storageItem.value, 'B', 'MB', true)
                    )
                  }}
                  <v-tooltip
                    bottom
                    v-if="checkIfIsImport($store.state.video.video)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="grey"
                        >mdi-download</v-icon
                      >
                    </template>
                    <span>
                      {{
                        $t(
                          'message.pages.qualitySettings.importDownloadWarning'
                        )
                      }}
                    </span>
                  </v-tooltip>
                  <v-btn
                    v-else
                    icon
                    class="no-disable"
                    @click="handleDownloadQuality(storageItem)"
                    color="primary"
                    :disabled="!hasEditVideoPerm"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </div>
                <div
                  style="width: 100%; text-align: center"
                  class="healthcheck-card pr-5"
                >
                  <template
                    v-if="
                      storageItem.statusM3u8 === 'error' ||
                      storageItem.statusTs === 'error'
                    "
                  >
                    <v-icon color="red"> mdi-close </v-icon>
                  </template>
                  <div
                    v-else-if="
                      storageItem.statusM3u8 === 'ok' &&
                      storageItem.statusTs === 'ok'
                    "
                  >
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="isConverting ? '#D7D7D7' : 'green'"
                            v-on="on"
                            v-bind="attrs"
                          >
                            mdi-check-bold
                          </v-icon>
                        </template>
                        <span>{{
                          $t('message.pages.qualitySettings.verifiedArchives', {
                            quality: storageItem.name,
                          })
                        }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                  <template
                    v-else-if="
                      isConverting &&
                      (storageItem.statusM3u8 == 'error' ||
                        storageItem.statusTs == 'error')
                    "
                  >
                    <v-icon color="red"> mdi-close </v-icon>
                  </template>
                  <template v-else-if="isConverting">
                    <v-icon color="#D7D7D7"> mdi-check-bold </v-icon>
                  </template>
                  <div
                    v-else-if="
                      storageItem.statusTs !== 'ok' &&
                      storageItem.statusTs !== 'error' &&
                      storageItem.name !== 'Backup' &&
                      storageItem.name !== 'Images' &&
                      storageItem.name !== 'Total'
                    "
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-progress-circular
                          :rotate="360"
                          :size="progressSize"
                          :width="30"
                          :value="storageItem.progressTs"
                          color="primary"
                          v-on="on"
                          v-bind="attrs"
                        >
                        </v-progress-circular>
                      </template>
                      {{
                        $t('message.pages.qualitySettings.verifyingArchives')
                      }}

                      {{ storageItem.name }}
                    </v-tooltip>
                  </div>
                  <template v-else>
                    <v-icon color="#fff"> mdi-check-bold </v-icon>
                  </template>
                </div>
                <div
                  style="text-align: center"
                  class="px-5"
                  v-if="
                    storageItem.name !== 'Backup' &&
                    storageItem.name !== 'Images' &&
                    storageItem.name !== 'Total' &&
                    storageItem.disabled !== true &&
                    isConverting !== true
                  "
                >
                  <v-radio-group
                    class="mt-0"
                    v-model="initQuality"
                    hide-details="true"
                  >
                    <v-radio
                      class="mt-0"
                      :disabled="!hasEditVideoPerm"
                      @click="handleInitialQuality"
                      :value="storageItem.name"
                      hide-details
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div
                  style="text-align: center"
                  class="px-5"
                  v-else-if="
                    storageItem.disabled === true || isConverting === true
                  "
                >
                  <v-radio-group
                    class="mt-0"
                    v-model="initQuality"
                    hide-details="true"
                  >
                    <v-radio
                      class="mt-0"
                      :disabled="true"
                      :value="storageItem.name"
                      hide-details
                    ></v-radio>
                  </v-radio-group>
                </div>
                <template v-else style="text-align: center">
                  <v-icon color="#fff" class="px-6"> mdi-check-bold </v-icon>
                </template>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-item
                class="justify-space-between unavailable-quality-container"
              >
                <div style="width: 100%" class="d-flex align-center">
                  {{ storageItem.name }}
                  <p
                    class="unavailable-quality unavailable-quality-button mb-0"
                  >
                    {{ $t('message.unavailable') }}
                  </p>
                </div>
              </v-list-item>
            </template>
          </v-card>
          <v-card
            flat
            v-for="(info, index) in extraInfo"
            :key="`${info.name}--${index}`"
            class="storage-video-card"
          >
            <div v-if="info.value > 99999">
              <v-list-item
                class="justify-space-between"
                :style="
                  index === sizes.length - 1 ? 'margin-bottom: -8px;' : ''
                "
              >
                <div style="width: 100%">
                  {{ info.name }}
                  {{ info.name.toLowerCase() === 'backup' ? 'original' : '' }}
                </div>
                <div style="width: 100%; text-align: right" class="pr-7">
                  <span :class="{ 'pr-10': info.name === 'Images' }">{{
                    addDecimal(calcMegabytes(info.value, 'B', 'MB', true))
                  }}</span>
                  <v-btn
                    v-if="video.backup && info.name === 'Backup'"
                    icon
                    class="no-disable"
                    color="primary"
                    @click="downloadVideo"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </div>
                <div style="width: 100%">
                  <template>
                    <v-icon class="opacity-0"> mdi-check-bold </v-icon>
                  </template>
                </div>
                <template>
                  <v-icon class="px-6 opacity-0"> mdi-check-bold </v-icon>
                </template>
              </v-list-item>
            </div>
          </v-card>
        </v-list>
      </v-card>
      <v-row no-gutters>
        <v-col
          cols="12"
          v-if="
            video.status === 'CONVERTED' &&
            (errors.testingTs || errors.testingM3u8)
          "
        >
          <v-btn
            color="primary"
            @click="handleReencodeVideo"
            :loading="loadings.reencode"
            :disabled="loadings.reencode"
            style="float: right; margin-bottom: 20px"
          >
            {{ $t('message.pages.qualitySettings.reencode') }}
          </v-btn>
        </v-col>
        <v-col cols="12" class="px-0 pt-1" v-if="errorsArray.length > 0">
          <v-alert type="error">
            <span>
              {{ $t('message.problemsWith') }}
            </span>
            <span v-for="(error, index) in errorsArray" :key="`${error.name}_`">
              <span v-if="index !== errorsArray.length - 1">
                {{ error.name }},
              </span>
              <span v-else> {{ error.name }}. </span>
            </span>
            <template slot="append">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon @click="handleShowLink()" v-bind="attrs" v-on="on"
                    >mdi-content-copy</v-icon
                  >
                </template>
                <span v-if="isCopied">
                  {{ $t('message.pages.videoEditModal.copied') }}
                </span>
                <span v-else>
                  {{ $t('message.pages.videoEditModal.copyToClipboard') }}
                </span>
              </v-tooltip>
            </template>
          </v-alert>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog v-model="showModal" width="600px">
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="pl-3 text--subtitle">
            <v-icon color="primary" style="padding-bottom: 4px">mdi-cog</v-icon>
            {{
              qualityToBeEnabled
                ? $t('message.pages.qualitySettings.enableX', {
                    quality: qualityToBeEnabled,
                  })
                : $t('message.pages.qualitySettings.disableX', {
                    quality: qualityToBeDisabled,
                  })
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="showModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0">
          <v-container class="pl-0">
            <v-row no-gutters>
              <v-col cols="12">
                <p
                  v-if="qualityToBeEnabled"
                  v-html="
                    $t('message.pages.qualitySettings.enablingMessage', {
                      quality: qualityToBeEnabled,
                    })
                  "
                ></p>
                <p
                  v-else-if="qualityToBeDisabled"
                  v-html="
                    $t('message.pages.qualitySettings.disablingMessage', {
                      quality: qualityToBeDisabled,
                    })
                  "
                ></p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-8 pb-6" v-if="hasEditVideoPerm">
          <v-spacer></v-spacer>
          <v-btn text class="mr-4 px-4" @click="showModal = false">
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            v-if="qualityToBeEnabled"
            class="primary white--text"
            min-width="185px"
            @click="handleActiveQuality"
            :loading="loadings.handlingQuality"
          >
            {{
              $t('message.pages.qualitySettings.enableX', {
                quality: qualityToBeEnabled,
              })
            }}
          </v-btn>
          <v-btn
            v-else-if="qualityToBeDisabled"
            class="red white--text"
            min-width="185px"
            @click="handleDeActiveQuality"
            :loading="loadings.handlingQuality"
          >
            {{
              $t('message.pages.qualitySettings.disableX', {
                quality: qualityToBeDisabled,
              })
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// external imports
import { mapState, mapMutations, mapActions } from 'vuex'
import * as m3u8Parser from 'm3u8-parser'
import axios from 'axios'
import _ from 'lodash'

// internal imports
import downloadUrlMixin from '@/utils/downloadUrl.mixin.js'
import calcMegabytesMixin from '@/utils/calcMegabytes'
import i18n from '@/translations/lang'
import { BACKUP_DOWNLOADER_SERVER } from '@/config/envs'
import Storage from '@/utils/Storage'
import store from '@/store'

// API
import videosApi from '@/services/videosApi'

// Components

export default {
  name: 'VideoPlayerQuality',
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    customVideoId: {
      required: false,
    },
  },
  mixins: [calcMegabytesMixin, downloadUrlMixin],
  data: function () {
    return {
      getStatusVideoTimeout: undefined,
      qualityToBeEnabled: '',
      qualityToBeDisabled: '',
      showModal: false,
      arrayFormatsAll: [],
      availableResolutionsShortened: [],
      videoSizes: ['240p', '360p', '480p', '720p', '1080p', '1440p', '2160p'],
      additionalResolutions: [],
      isCopied: false,
      loadings: {
        fetch: true,
        handlingQuality: false,
        reencode: false,
      },
      errors: {
        fetch: false,
        testingM3u8: false,
        testingTs: false,
      },
      videoId: '',
      profileId: null,
      sizes: [],
      testingM3u8: true,
      interval: {},
      progressTs: 0,
      progressSize: 100,
      initQuality: '',
      arrayFormats: [],
      extraInfo: [],
      storageSizeDetails: {},
      playback: [],
      m3u8HealthBackup: [],
      firstInitQuality: '',
      isConverting: false,
      downloadServer: undefined,
      authToken: '',
      qualityToBeDownloaded: '',
    }
  },
  async mounted() {
    this.authToken = Storage.getItem('accessToken')
    this.videoId = this.customVideoId
      ? this.customVideoId
      : this.$route.params.id
    this.profileId = this.video.config?.profile
    this.initQuality = this.profile.saveProgress?.initQuality
      ? this.profile.saveProgress?.initQuality
      : ''
    if (this.video.status === 'CONVERTING' || this.video.status === 'DRAFT') {
      this.handleVideoQualitiesConverting()
    } else {
      this.handleVideoQualities()
    }
  },
  methods: {
    ...mapActions('video', [
      'updateProfile',
      'createProfile',
      'setProfileToVideos',
    ]),
    ...mapMutations('video', [
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_VIDEO_PROFILE_ID',
      'UPDATE_STATUS_ERROR',
      'UPDATE_VIDEO',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    getStandardResolutionValue(value) {
      if (!~value.indexOf('p')) {
        const [value_1, value_2] = value.split('x')
        const [width, height] = [Number(value_1), Number(value_2)]

        return Math.min(width, height)
      }
      return value.slice(0, -1)
    },
    async downloadVideo() {
      this.qualityToBeDownloaded = null
      let downloadServer = Storage.getItem('downloaderServer')
      if (downloadServer) {
        this.downloadServer = downloadServer
      } else {
        this.downloadServer = BACKUP_DOWNLOADER_SERVER
      }
      const session = await store().dispatch('session/refreshSession')
      const token = session.accessToken.jwtToken
      this.authToken = token
      setTimeout(() => {
        this.$refs.downloadForm.submit()
      }, 1000)
    },
    async handleDownloadQuality({ name }) {
      const qualityToBeDownloaded = name.slice(0, -1)
      const qualitiesFullName = Object.keys(this.storageSizeDetails)
      const qualityToBeDownloadedFullName = qualitiesFullName.filter(
        (quality) => {
          if (quality.indexOf(qualityToBeDownloaded) !== -1) {
            return true
          }
        }
      )[0]
      this.qualityToBeDownloaded = qualityToBeDownloadedFullName
      let downloadServer = Storage.getItem('downloaderServer')
      if (downloadServer) {
        this.downloadServer = downloadServer
      } else {
        this.downloadServer = BACKUP_DOWNLOADER_SERVER
      }
      const session = await store().dispatch('session/refreshSession')
      const token = session.accessToken.jwtToken
      this.authToken = token
      setTimeout(() => {
        this.$refs.downloadForm.submit()
      }, 1000)
    },
    async handleVideoQualities(hotReload = false) {
      this.isConverting = false
      await this.handleHealthCheckM3u8()
      await this.fetchData(hotReload)
      this.checkIfTheActiveQualityWasDisabled()
      await this.checkHealthy()
    },
    async handleVideoQualitiesConverting(hotReload = false) {
      this.isConverting = true
      await this.fetchData(hotReload)
      this.checkIfTheActiveQualityWasDisabled()
      await this.getStatusVideo()
    },
    handleActiveTheHighestQuality() {
      let mappedPlaylist = this.playback.map((val) => Number(val.slice(0, -1)))
      let maxQuality = Math.max(...mappedPlaylist)
      let maxQualityIndex = mappedPlaylist.indexOf(maxQuality)
      this.firstInitQuality = this.initQuality
      this.initQuality = this.playback[maxQualityIndex]
      this.handleInitialQuality(false)
    },
    async checkIfTheActiveQualityWasDisabled() {
      let initQuality = String(this.initQuality)
      if (initQuality.indexOf('p') === -1) initQuality += 'p'

      let index = this.playback.indexOf(`${initQuality}`)

      if (index === -1) {
        this.handleActiveTheHighestQuality()
      } else {
        this.initQuality = this.playback[index]
        this.firstInitQuality = this.initQuality
      }
    },
    async handleActiveQuality() {
      try {
        this.loadings.handlingQuality = true
        let playbacks = Array.from(this.playback)
        playbacks.push(this.qualityToBeEnabled)

        await videosApi.updateVideoPlayback(this.videoId, playbacks)
        await this.updateList()
        this.sizes.map(
          function (val, i) {
            val.statusM3u8 = this.m3u8HealthBackup[i].statusM3u8
            val.statusTs = this.m3u8HealthBackup[i].statusTs
            return val
          }.bind(this)
        )
        await this.checkIfTheActiveQualityWasDisabled()
        this.showModal = false
        this.loadings.handlingQuality = false
      } catch (err) {
        this.loadings.handlingQuality = false
        console.error(err)
      }
    },
    async handleDeActiveQuality() {
      if (this.playback.length <= 1) {
        this.handleShowDisabledLimit()
        this.showModal = false
        return
      }
      try {
        this.loadings.handlingQuality = true
        let playbacks = Array.from(this.playback)
        let index = playbacks.indexOf(this.qualityToBeDisabled)
        playbacks.splice(index, 1)

        await videosApi.updateVideoPlayback(this.videoId, playbacks)
        await this.updateList()
        this.sizes.map(
          function (val, i) {
            val.statusM3u8 = this.m3u8HealthBackup[i].statusM3u8
            val.statusTs = this.m3u8HealthBackup[i].statusTs
            return val
          }.bind(this)
        )
        await this.checkIfTheActiveQualityWasDisabled()
        this.showModal = false
        this.loadings.handlingQuality = false
      } catch (err) {
        console.error(err)
        this.loadings.handlingQuality = false
      }
    },
    handleShowModal(quality, toBeDisabled = false) {
      if (toBeDisabled) {
        this.qualityToBeDisabled = quality
        this.qualityToBeEnabled = ''
      } else {
        this.qualityToBeEnabled = quality
        this.qualityToBeDisabled = ''
      }

      this.showModal = true
    },
    handleShowLink() {
      this.isCopied = true
      navigator.clipboard.writeText(
        `${JSON.stringify(this.errorsArray)}, ${JSON.stringify({
          videoId: this.videoId,
        })}`
      )
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    },
    handleShowReencode() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.reencoded'),
      })
    },
    handleShowDisabledLimit() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t(
          'message.pages.qualitySettings.disablingAllQualitiesMessage'
        ),
      })
    },
    async fetchData(hotReload = false) {
      if (hotReload === true) {
        await this.updateList()
      } else {
        this.loadings.fetch = true
        await this.updateList()
        this.loadings.fetch = false
      }
    },
    async updateList() {
      try {
        const response = await videosApi.getVideoStorageSize(
          this.customVideoId ? this.customVideoId : this.$route.params.id
        )
        this.storageSizeDetails = response.data.storage_size_details

        let availableResolutionsShortened = []
        let numberResolutions = []

        let sizes = Object.keys(this.storageSizeDetails).map((item) => {
          let name
          if (!~item.indexOf('x')) {
            name = item[0].toUpperCase() + item.slice(1)
            availableResolutionsShortened.push(name)
          } else {
            name = this.getStandardResolutionValue(item)
            numberResolutions.push(Number(name))
            name = name + 'p'
            availableResolutionsShortened.push(name)
          }

          return {
            name,
            value: this.storageSizeDetails[item],
          }
        })

        this.availableResolutionsShortened = availableResolutionsShortened

        this.playback = response.data.playback.filter((playbackQuality) => {
          let indexOfAvailable =
            availableResolutionsShortened.indexOf(playbackQuality)
          if (indexOfAvailable !== -1) return playbackQuality
        })

        sizes.push({
          name: 'Total',
          value: Object.values(this.storageSizeDetails).reduce(
            (previous, current) => previous + current,
            0
          ),
        })
        sizes = sizes.sort((a, b) =>
          Number(a.name.replace('p', '')) < Number(b.name.replace('p', ''))
            ? 1
            : -1
        )
        sizes = sizes.reverse()
        let extraInfo = []

        sizes = sizes.filter((obj) => {
          if (
            obj.name !== 'Total' &&
            obj.name !== 'Backup' &&
            obj.name !== 'Images'
          ) {
            return obj
          }
          extraInfo.push(obj)
          return false
        })

        extraInfo.sort((a, b) => {
          if ('Total' === a.name) return 1
          if ('Total' === b.name) return -1

          return 0
        })

        this.extraInfo = extraInfo

        sizes = sizes.map((size) => {
          if (this.playback.indexOf(size.name) === -1) {
            size.disabled = true
          }
          return size
        })
        if (this.sizes.length) {
          this.sizes = this.sizes.map((size, index) => {
            const updateObject = sizes[index]
            updateObject.progressTs = size.progressTs
            updateObject.statusTs = size.statusTs
            updateObject.statusM3u8 = size.statusM3u8
            return updateObject
          })
        } else {
          this.sizes = sizes
        }
        this.errors.fetch = false
      } catch (err) {
        console.log(err)
        this.errors.fetch = true
      }
    },
    async handleReencodeVideo() {
      try {
        this.loadings.reencode = true
        await videosApi.reencodeVideo(this.videoId)
        await this.getStatusVideo()
        this.handleVideoQualitiesConverting(true)
        this.handleShowReencode()
        this.video.status = 'CONVERTING'
        this.loadings.reencode = false
      } catch (error) {
        console.log(error)
      }
    },
    clearSizes() {
      const mustBeRemoved = ['statusTs', 'statusM3u8', 'progressTs']
      this.sizes.map((val) => {
        let finalValue = val
        mustBeRemoved.forEach((key) => {
          if (finalValue.hasOwnProperty(key)) {
            delete finalValue[key]
          }
        })
      })
    },
    async getStatusVideo() {
      let video = ''
      if (document.visibilityState && document.visibilityState != 'visible') {
        return
      }
      if (this.getStatusVideoTimeout === undefined) {
        this.getStatusVideoTimeout = setInterval(async () => {
          video = await videosApi.getAVideo(this.videoId)
          if (
            video.data.status === 'DRAFT' ||
            video.data.status === 'CONVERTING'
          ) {
            this.UPDATE_VIDEO(video.data)
          } else {
            clearInterval(this.getStatusVideoTimeout)
            this.getStatusVideoTimeout = undefined
            this.clearSizes()
            this.$root.$emit('updateVideoInfo', video.data)
            this.UPDATE_VIDEO(video.data)
            this.handleVideoQualities(true)
          }
        }, 5000)
      }
    },
    checkIfIsImport(video) {
      if (!video.description) return
      const desc = video.description
      let val = desc.includes('hotmart') || desc.includes('vimeo')
      return val
    },
    async handleInitialQuality(showSnackbar = true) {
      if (this.initQuality === this.firstInitQuality) {
        if (showSnackbar) {
          this.handleSnackbar()
        }

        return
      }

      let initialQuality = ''
      if (this.initQuality) {
        this.firstInitQuality = this.initQuality
        initialQuality = parseInt(this.initQuality.slice(0, -1))
      }

      const saveProgress = {
        initQuality: initialQuality,
        saveProgress: this.$store.state.video.profile.saveProgress.saveProgress,
        saveProgressScreen:
          this.$store.state.video.profile.saveProgress.saveProgressScreen,
        saveProgressTitle:
          this.$store.state.video.profile.saveProgress.saveProgressTitle,
        saveProgressBackgroundOpacity:
          this.$store.state.video.profile.saveProgress
            .saveProgressBackgroundOpacity,
        saveProgressBackgroundOpacityFormated:
          this.$store.state.video.profile.saveProgress
            .saveProgressBackgroundOpacity,
        saveProgressButton1Title:
          this.$store.state.video.profile.saveProgress.saveProgressButton1Title,
        saveProgressButton2Title:
          this.$store.state.video.profile.saveProgress.saveProgressButton2Title,
      }
      if (!this.video.config.profile) {
        await this.createProfile(this.videoId)
        this.video.config.profile = this.profile_id
        this.profileId = this.profile_id
        await this.setProfileToVideos([this.profileId, this.videoId])
      }
      const controls = this.$store.state.video.profile.controls
      const colors = this.$store.state.video.profile.colors
      try {
        await this.updateProfile([
          this.profileId,
          {
            colors: colors,
            controls: controls,
            saveProgress: saveProgress,
          },
        ])
        if (showSnackbar && !this.internalError) {
          this.handleSnackbar()
        }
      } catch (e) {
        console.error(e)
      }
    },
    async handleHealthCheckM3u8() {
      const endpointAll = `https://b-${this.video.pullzone_name}.tv.pandavideo.com.br/${this.video.video_external_id}/playlist.m3u8?all=1`
      const endpoint = `https://b-${this.video.pullzone_name}.tv.pandavideo.com.br/${this.video.video_external_id}/playlist.m3u8`
      try {
        const retAll = await axios.get(endpointAll)
        const ret = await axios.get(endpoint)
        let manifestAll = retAll.data
        let manifest = ret.data
        let parser = new m3u8Parser.Parser()
        let parserAll = new m3u8Parser.Parser()
        parser.push(manifest)
        parser.end()
        parserAll.push(manifestAll)
        parserAll.end()
        let parsedManifestAll = parserAll.manifest.playlists
        let parsedManifest = parser.manifest.playlists
        const arrayFormats = parsedManifest.map((item) => {
          return this.getManifestQuality(item)
        })
        const arrayFormatsAll = parsedManifestAll.map((item) => {
          return this.getManifestQuality(item)
        })
        this.arrayFormatsAll = arrayFormatsAll
        this.arrayFormats = arrayFormats
      } catch (error) {
        console.log(error)
      }
    },
    getManifestQuality(item) {
      if (!~item.uri.indexOf('p')) {
        return `${item.attributes.RESOLUTION.width}x${item.attributes.RESOLUTION.height}`
      }
      return `${item.uri.split('/')[0]}`
    },
    async checkHealthy() {
      try {
        await this.handleCheckAllFormatsM3u8(this.arrayFormatsAll)
        await this.handleHealthCheckTs(this.arrayFormatsAll)
      } catch (err) {
        console.error(err)
      }
    },
    async handleCheckAllFormatsM3u8(formats) {
      let sizeArray = this.sizes.map((size) => size.name.slice(0, -1))
      for (let i in formats) {
        let ret = ''
        let endpoint = `https://b-${this.video.pullzone_name}.tv.pandavideo.com.br/${this.video.video_external_id}/${formats[i]}/video.m3u8`
        try {
          ret = await axios.get(endpoint)
        } catch (error) {
          this.errors.testingM3u8 = true
          console.log(error)
        }
        const stringQuality = this.getStandardResolutionValue(formats[i])
        let index = sizeArray.indexOf(String(stringQuality))
        let theSize = this.sizes[index]
        if (ret.status === 200) {
          theSize['statusM3u8'] = 'ok'
        } else {
          theSize['statusM3u8'] = 'error'
        }
      }
      this.testingM3u8 = false
    },
    async handleHealthCheckTs(formats) {
      for (let i in formats) {
        if (this.video.status === 'CONVERTING') break
        const resolution = this.getStandardResolutionValue(formats[i])
        let endpoint = `https://b-${this.video.pullzone_name}.tv.pandavideo.com.br/${this.video.video_external_id}/${formats[i]}/video.m3u8`
        try {
          const ret = await axios.get(endpoint)
          let manifest = ret.data
          let parser = new m3u8Parser.Parser()
          parser.push(manifest)
          parser.end()
          let parsedManifest = parser.manifest.segments
          const arrayUrls = parsedManifest.map((item) => {
            const resolutions = item.uri
            return resolutions
          })
          let res = await this.handleCheckAllFormatsTs(arrayUrls, resolution)
          if (res === false) break
        } catch (error) {
          this.loadMessage({}, [], resolution, true)
          console.log(error)
        }
        this.m3u8HealthBackup = this.sizes
      }
    },
    async handleCheckAllFormatsTs(arrayUrls, quality) {
      let arrayResponse = []
      let arrayContentTypes = []
      let promiseControl = 0
      for (let i in arrayUrls) {
        if (this.video.status === 'CONVERTING') break
        const item = arrayUrls[i]
        try {
          const ret = await axios.head(item)
          const status = ret.status
          arrayResponse.push(status)
          arrayContentTypes.push(ret.headers['content-type'])
          if (status === 200)
            this.verifyAndSend(arrayResponse, arrayUrls, quality)
        } catch (e) {
          arrayResponse.push(e.response.status)
        }
        if (i !== 0 && i !== arrayUrls.length - 1 && promiseControl === 40) {
          promiseControl = 0
          await this.delay(1500)
        }
        promiseControl++
      }
      if (this.video.status === 'CONVERTING') return false
      try {
        this.loadMessage(
          { arrayResponse, arrayContentTypes, finished: arrayResponse.length },
          arrayUrls,
          quality
        )
      } catch (err) {
        console.error(err)
        this.loadMessage(
          { arrayResponse, arrayContentTypes, finished: arrayResponse.length },
          arrayUrls,
          quality
        )
      }
      this.verifyAndSend(arrayResponse, arrayUrls, quality)
      return new Promise((resolve) => resolve())
    },
    addDecimal(lengthString) {
      let numberPart = lengthString.split(' ')[0]
      let strPart = lengthString.split(' ')[1]

      numberPart = Number(numberPart).toFixed(1)
      return `${numberPart} ${strPart}`
    },
    verifyAndSend(arrayResponse, arrayUrls, quality) {
      this.loadMessage(
        { finished: arrayResponse.length, type: 'progress' },
        arrayUrls,
        quality
      )
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    loadMessage(data, arrayUrls, quality, confirmedError = false) {
      if (confirmedError) {
        this.sizes = this.sizes.map((item) => {
          if (quality == item.name.slice(0, -1)) {
            this.errors.testingTs = true
            return { ...item, statusTs: 'error' }
          }
          return item
        })
        return
      }
      if (data.type === 'progress') {
        const finished = data.finished
        let total = arrayUrls.length
        let progress = (finished * 100) / total

        this.sizes = this.sizes.map((item) => {
          if (quality == item.name.slice(0, -1)) {
            return { ...item, progressTs: progress }
          }
          return item
        })
        return
      }
      const arrayStatus = _.cloneDeep(data.arrayResponse)
      const arrayContentType = _.cloneDeep(data.arrayContentTypes)
      const status = arrayStatus.every((result) => {
        return result === 200
      })
      const contentType = arrayContentType.every(
        (result) => result === 'video/mp2t'
      )
      this.sizes = this.sizes.map((item) => {
        if (quality == item.name.slice(0, -1)) {
          if (contentType && status) {
            return { ...item, statusTs: 'ok' }
          } else if (!status) {
            this.errors.testingTs = true
            return { ...item, statusTs: 'error' }
          }
        }
        return item
      })
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.pages.video.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
  },
  computed: {
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    extraResolutions() {
      let arr = []
      this.videoSizes.map(
        function (val) {
          let valIndex = this.availableResolutionsShortened.indexOf(val)
          if (valIndex === -1) arr.push(val)
        }.bind(this)
      )

      return arr
    },
    errorsArray() {
      let errorsArray = this.sizes.filter((item) => {
        if (item.statusM3u8 === 'error' || item.statusTs === 'error') {
          return item
        }
      })

      return errorsArray
    },
    sizesList() {
      return [...this.sizes, ...this.extraResolutions]
        .sort((a, b) => {
          const _a = parseInt((a.name ?? a).replace('p', ''))
          const _b = parseInt((b.name ?? b).replace('p', ''))
          return _a - _b
        })
        .map((size) => {
          if (size.name) return { ...size, available: true }
          else return { name: size, available: false }
        })
    },
    ...mapState({
      profile: (state) => state.video.profile,
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
    }),
  },
}
</script>

<style scoped>
.opacity-0 {
  opacity: 0;
}
</style>

<style lang="scss">
.list-storage-video {
  .storage-video-card {
    &:nth-last-child(1) {
      border-radius: 0;
      border-top: 1px solid #666;
      font-weight: bold;
    }
  }
}

.healthcheck-card {
  .v-progress-circular {
    width: 32px !important;
    height: 32px !important;
  }
}

.unavailable-quality {
  transform: translate(8px, 0px);
  margin-bottom: 0px !important;
  text-align: right;
  font-size: 13px;

  &-button {
    background-color: #9b9b9b;
    padding: 0px 4px;
    border-radius: 4px;
  }

  &-container * {
    color: rgb(221, 221, 221);
  }
}

.quality-button {
  background-color: #d7d7d7;
  padding: 0px 4px;
  border-radius: 4px;
}

.disabled-quality {
  *:not(.healthcheck-card *) {
    color: gray;

    .mdi-download {
      color: var(--v-primary-base);
    }
  }
}

.enabled-quality {
  background-color: #4caf50;
  color: #fff;
}
</style>
